import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Página inicial do chat anônimo ${ctx.brand}`,
    languageButtonLabel: `Idioma`,
    languageModalTitle: `Escolha um idioma`,
    languageModalCloseLabel: `Fechar menu de idiomas`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglês (Estados Unidos)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglês (Quênia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglês (Nigéria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglês (Singapura)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Português (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Alemão (Alemanha)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Alemão (Áustria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Alemão (Suíça)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Espanhol (Espanha)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francês (França)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano (Itália)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Holandês (Países Baixos)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polonês (Polônia)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Sueco (Suécia)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dinamarquês (Dinamarca)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finlandês (Finlândia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norueguês (Noruega)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandês (Islândia)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonês (Japão)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano (Coreia do Sul)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Chinês (China)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonês (Hong Kong, RAE da China)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamita (Vietnã)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tailandês (Tailândia)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonésio (Indonésia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Suaíli (Quênia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Híndi (Índia)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marati (Índia)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Télugo (Índia)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persa (Irã)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Paquistão)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Panjabi (Paquistão)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin nigeriano (Nigéria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russo (Rússia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Árabe (Arábia Saudita)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Árabe (Emirados Árabes Unidos)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Árabe (Catar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Árabe marroquino (Marrocos)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turco (Turquia)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Escolha um idioma`,
    closeLabel: `Fechar menu de idiomas`,
  },
  languageHint: (ctx) => `Passeie por ${ctx.localesCount}+ idiomas sem criar conta.`,
  readPagePrompt: ({languageLabel}) => `Leia esta página em ${languageLabel}.`,
};
